import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const EditPersonalInformation = dynamic(() =>
  import('./EditPersonalInformation').then(mod => mod.EditPersonalInformation)
);
const EditPersonalInformationConfig = {
  emptyLabel: 'editpersonalinformation',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/editpersonalinformation`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EditPersonalInformationEditable = (authorModelData: any) => {
  return authorModelData?.cqPath?.includes('datapagecomponent') ? (
    <EditPersonalInformation {...authorModelData} />
  ) : (
    <EditableComponent config={EditPersonalInformationConfig} {...authorModelData}>
      <EditPersonalInformation {...authorModelData} />
    </EditableComponent>
  );
};
